import React from 'react'
import IndicatorItem from './IndicatorItem'

const IndicatorSummary = ({
  config = [],
  values = {}
}) => {
  if (!config.length) return null

  return (
    <div className="assign-document-div mb-20">
      <div className="oc-orders-indicator-background">
        {config.map(item => {
          const value = values[item.key] ?? 0

          return (
            <IndicatorItem
              key={item.key}
              title={item.title}
              icon={item.icon}
              iconClass={item.iconClass}
              text={`${item.label}: ${value}${item.suffix || ''}`}
            />
          )
        })}
      </div>
    </div>
  )
}

export default IndicatorSummary
